"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
/* eslint-disable react/button-has-type */
const react_1 = __importStar(require("react"));
exports.Button = ({ children, theme = 'light', type = 'primary', variant, disabled, icon, dropdown, fill, className, htmlType = 'button', onClick, onMouseDown, id, }) => {
    const renderDropdown = react_1.useCallback(() => {
        if (!dropdown)
            return react_1.default.createElement(react_1.default.Fragment, null);
        if (dropdown && type === 'pill') {
            return react_1.default.createElement("i", { className: "material-icons" }, "arrow_drop_down");
        }
        return react_1.default.createElement("i", { className: "material-icons" }, "expand_more");
    }, [dropdown, type]);
    return (react_1.default.createElement("div", { className: "new-button" },
        react_1.default.createElement("button", { onClick: onClick, onMouseDown: onMouseDown, type: htmlType, className: `button button-${type}
          ${theme === 'dark' ? 'button-dark' : ''}
          ${variant === 'circle' ? 'button-circle' : ''}
          ${icon && 'button-icon'}
          ${dropdown ? 'button-dropdown' : ''}
          ${fill ? 'button-fill' : ''}
          ${className}
        `, disabled: disabled, id: id },
            react_1.default.createElement("span", { className: `
          ${dropdown ? 'button-dropdown' : ''}
          ${icon && 'button-icon'}
        ` },
                icon && react_1.default.createElement("div", { className: "icon" }, icon),
                children && variant !== 'circle' && children,
                renderDropdown()))));
};
//# sourceMappingURL=index.js.map